"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STICKER_SETTINGS_DESCRIPTIONS = exports.STICKER_SETTINGS_LABELS = exports.STICKER_SETTINGS_RANGES = exports.STICKER_SETTINGS_TOGGLE_KEYS = void 0;
exports.buildDefaultStickerSettingsConfig = buildDefaultStickerSettingsConfig;
exports.parseStickerSettingsConfig = parseStickerSettingsConfig;
exports.validateStickerSettingsConfigForSave = validateStickerSettingsConfigForSave;
exports.STICKER_SETTINGS_TOGGLE_KEYS = ['momentsPermanentByDefault', 'notesPermanentByDefault'];
exports.STICKER_SETTINGS_RANGES = {
  momentLifetimeHours: {
    min: 1,
    max: 24 * 30
  },
  maxMomentsPerWindow: {
    min: 1,
    max: 100
  },
  maxNotesPerWindow: {
    min: 0,
    max: 100
  },
  limitWindowHours: {
    min: 1,
    max: 24 * 30
  },
  noteLifetimeDays: {
    min: 1,
    max: 365
  }
};
exports.STICKER_SETTINGS_LABELS = {
  momentLifetimeHours: 'Temporary moment lifetime (hours)',
  maxMomentsPerWindow: 'Moments per user per venue',
  maxNotesPerWindow: 'Notes per user per venue (0 = no limit)',
  limitWindowHours: 'Limit window (hours)',
  noteLifetimeDays: 'Temporary note lifetime (days)',
  momentsPermanentByDefault: 'Moments start as permanent',
  notesPermanentByDefault: 'Notes start as permanent'
};
exports.STICKER_SETTINGS_DESCRIPTIONS = {
  momentLifetimeHours: 'Shown on the app\'s timer button ("24") and used for new temporary moments.',
  maxMomentsPerWindow: 'How many moments one person can post at one venue within the limit window (kept and temporary count).',
  maxNotesPerWindow: 'How many notes one person can post at one venue within the limit window.',
  limitWindowHours: 'The rolling window both limits count over, e.g. 24 = per day.',
  noteLifetimeDays: 'Used for new notes posted as "Temporary".',
  momentsPermanentByDefault: 'On: the app\'s moment screen starts on "Keep it on my profile". Off: it starts on temporary. The poster can always switch.',
  notesPermanentByDefault: 'On: the app\'s note screen starts on "Keep it on my profile". Off: it starts on "Temporary". The poster can always switch.'
};
function buildDefaultStickerSettingsConfig() {
  return {
    momentLifetimeHours: 24,
    maxMomentsPerWindow: 1,
    maxNotesPerWindow: 0,
    limitWindowHours: 24,
    noteLifetimeDays: 30,
    momentsPermanentByDefault: true,
    notesPermanentByDefault: true
  };
}
function intInRange(value, fallback, min, max) {
  return typeof value === 'number' && Number.isInteger(value) && value >= min && value <= max ? value : fallback;
}
/** Lenient: any missing or out-of-range field falls back to its default. */
function parseStickerSettingsConfig(raw) {
  const defaults = buildDefaultStickerSettingsConfig();
  if (!raw || typeof raw !== 'object') return defaults;
  const value = raw;
  const out = _objectSpread({}, defaults);
  for (const key of Object.keys(exports.STICKER_SETTINGS_RANGES)) {
    const {
      min,
      max
    } = exports.STICKER_SETTINGS_RANGES[key];
    out[key] = intInRange(value[key], defaults[key], min, max);
  }
  for (const key of exports.STICKER_SETTINGS_TOGGLE_KEYS) {
    if (typeof value[key] === 'boolean') out[key] = value[key];
  }
  return out;
}
/** Strict, for saving from the admin: every field must be an integer in range. */
function validateStickerSettingsConfigForSave(value) {
  if (!value || typeof value !== 'object') return {
    message: 'Sticker settings must be an object.'
  };
  const config = value;
  for (const key of exports.STICKER_SETTINGS_TOGGLE_KEYS) {
    if (typeof config[key] !== 'boolean') return {
      message: "".concat(exports.STICKER_SETTINGS_LABELS[key], " must be on or off.")
    };
  }
  for (const key of Object.keys(exports.STICKER_SETTINGS_RANGES)) {
    const {
      min,
      max
    } = exports.STICKER_SETTINGS_RANGES[key];
    const raw = config[key];
    if (typeof raw !== 'number' || !Number.isInteger(raw)) {
      return {
        message: "".concat(exports.STICKER_SETTINGS_LABELS[key], " must be a whole number.")
      };
    }
    if (raw < min || raw > max) {
      return {
        message: "".concat(exports.STICKER_SETTINGS_LABELS[key], " must be between ").concat(min, " and ").concat(max, ".")
      };
    }
  }
  return null;
}
//# sourceMappingURL=sticker-settings-config.js.map